import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate, dvUpdate, dvDelete } from '../api/dataverseClient';
import { Lesson } from '../types';

const FIELDS = [
  'dagrun_pm_lessonid', 'dagrun_pm_name', 'dagrun_pm_category',
  'dagrun_pm_description', 'dagrun_pm_impact', 'dagrun_pm_recommendation',
  'dagrun_pm_loggedbyid', 'dagrun_pm_loggedbyname', 'dagrun_pm_loggedon',
  'dagrun_pm_phase', 'dagrun_pm_tags', 'dagrun_pm_projectid',
  'createdon',
];

export async function getProjectLessons(pca: IPublicClientApplication, projectId: string): Promise<Lesson[]> {
  return dvList<Lesson>(pca, 'dagrun_pm_lessons', {
    select: FIELDS,
    filter: `dagrun_pm_projectid eq '${projectId}'`,
    orderby: 'dagrun_pm_loggedon desc',
    top: 500,
  });
}

export interface CreateLessonInput {
  projectId: string;
  name: string;
  category?: number;
  description?: string | null;
  impact?: string | null;
  recommendation?: string | null;
  loggedbyid?: string | null;
  loggedbyname?: string | null;
  phase?: string | null;
  tags?: string | null;
}

export async function createLesson(pca: IPublicClientApplication, input: CreateLessonInput): Promise<string> {
  const body: Record<string, unknown> = {
    dagrun_pm_name: input.name,
    dagrun_pm_projectid: input.projectId,
    dagrun_pm_loggedon: new Date().toISOString(),
  };
  if (input.category != null)    body.dagrun_pm_category = input.category;
  if (input.description)         body.dagrun_pm_description = input.description;
  if (input.impact)              body.dagrun_pm_impact = input.impact;
  if (input.recommendation)      body.dagrun_pm_recommendation = input.recommendation;
  if (input.loggedbyid)          body.dagrun_pm_loggedbyid = input.loggedbyid;
  if (input.loggedbyname)        body.dagrun_pm_loggedbyname = input.loggedbyname;
  if (input.phase)               body.dagrun_pm_phase = input.phase;
  if (input.tags)                body.dagrun_pm_tags = input.tags;
  return dvCreate(pca, 'dagrun_pm_lessons', body);
}

export async function updateLesson(pca: IPublicClientApplication, id: string, patch: Record<string, unknown>): Promise<void> {
  return dvUpdate(pca, 'dagrun_pm_lessons', id, patch);
}

export async function deleteLesson(pca: IPublicClientApplication, id: string): Promise<void> {
  return dvDelete(pca, 'dagrun_pm_lessons', id);
}
